import React, { useEffect } from 'react';

const RhodiumLife = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="section" id="rhodium-life">
      <div className="header">
        <h1>Rhodium Life</h1>
        <h2>Your personal health operating system</h2>
        <hr className="custom-line" />
      </div>

      <div className="text-image-wrapper">
        <img
          src="/images/RhodiumLifeHome.png"
          alt="Rhodium Life iPhone app preview"
          className="journey-image"
          style={{ height: 'auto', maxHeight: '520px', objectFit: 'contain' }}
        />
        <p>
          Rhodium Life turns biomarker, fitness, and nutrition inputs into a clear daily picture so decisions are driven by data.
          <br />
          <br />
          Your data stays on your device. No data is sent to any servers or third parties except for the AI key you provide to access AI features.
          <br />
          <br />
          <a
            className="card-container-button"
            href="https://apps.apple.com/app/id6756220909"
            target="_blank"
            rel="noreferrer"
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            View Rhodium Life on the App Store
          </a>
          <br />
          <br />
          <a
            className="card-container-button"
            href="/legal/privacy"
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            Privacy Policy
          </a>
          <a
            className="card-container-button"
            href="/legal/terms"
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            Terms & Conditions
          </a>
        </p>
      </div>

      <h2>What you can do with the app</h2>
      <div className="card-container">
        <div className="card">
          <h3>Import Biomarkers</h3>
          <i>PDF and CSV support</i>
          <p>
            Import lab results from supported PDFs and CSV files, track trends over time, and see what values are optimal, normal, high, or low.
          </p>
        </div>

        <div className="card">
          <h3>Apple Health Integration</h3>
          <i>Read and write HealthKit data</i>
          <p>
            Connect Apple Health to incorporate fitness and health signals into your tracking and analysis. Imported biomarkers can be written back to Apple Health when enabled.
          </p>
        </div>

        <div className="card">
          <h3>Indicators of Harm</h3>
          <i>Rule-based, citation-backed patterns</i>
          <p>
            A deterministic, evidence-based rules engine highlights potentially concerning biomarker patterns based on published clinical research.
          </p>
        </div>

        <div className="card">
          <h3>AI Insights (Optional)</h3>
          <i>OpenAI-compatible or local providers</i>
          <p>
            Use AI to summarize flagged biomarkers, suggest questions to ask your doctor, and explore fitness and nutrition optimizations. You can use cloud providers with your own API key or local providers like Ollama / LM Studio.
          </p>
        </div>

        <div className="card">
          <h3>Food, Hydration, and Supplements</h3>
          <i>Track day-to-day inputs</i>
          <p>
            Log meals, hydration, and supplements. Use photo-based import to extract supplement labels and nutrition information using AI analysis.
          </p>
        </div>

        <div className="card">
          <h3>Workouts and Performance</h3>
          <i>Plans and trends</i>
          <p>
            Track performance signals and generate workout routines (including options that account for available equipment and injuries).
          </p>
        </div>
      </div>

      <h2>FAQ</h2>
      <div className="card-container">
        <div className="card">
          <h3>Where is my data stored?</h3>
          <p>
            Your health data is stored locally on your device and may be synced with Apple HealthKit. We do not store your personal health information on external servers.
          </p>
        </div>

        <div className="card">
          <h3>Is my data sent to AI providers?</h3>
          <p>
            Only the specific data needed for the requested analysis is sent to your configured AI provider. For maximum privacy, you can configure a local AI provider.
          </p>
        </div>

        <div className="card">
          <h3>Is this medical advice?</h3>
          <p>
            No. Rhodium Life is for educational purposes only and is not a substitute for professional medical advice, diagnosis, or treatment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RhodiumLife;
